import React, {useState} from "react";
import ModalBox from "components/Alert/Modal.js";
import Spinner from "components/Alert/Spinner";
import Paypal from "components/Common/Paypal";
import useAuth from "components/Common/UseAuth";

export default function CardLine(props) {  
  let [loading, setLoading] = useState(false);
  const {checkSession,user}=useAuth();

  const [modalDetail, setModalDetail] = useState("");  
  const showModal = (title,desc) => {
    setModalDetail(<ModalBox title={title} desc={desc} show="true" callback={()=>{
        setModalDetail(<div></div>);
        setLoading(false);
    }}/>);
  }

  const PaymentSuccess = () => {    
    setLoading(false);
    checkSession();
    showModal("MBLink Payment Method",
        <>     
          <span>Thank you for purchasing...</span>   
        </>  
    );
  }

  const PaymentError = (err) => {
    setLoading(false);
    showModal("MBLink Payment Method",
        <>     
          <span>Payment could not be received. Please try again!</span>   
        </>  
    );
  }

  const PaymentStart = () => {
    setLoading(true);
  }  

  const doPayment = (price) => {
    showModal("MBLink Payment Method",
        <>     
          <Paypal sku={props.sku} onSuccess={PaymentSuccess} onError={PaymentError} onStartTransaction={PaymentStart}></Paypal>   
        </>  
    );
  }

  const getPrice = (sku) => {
    let price = 0;
    user.availabletokens.forEach(skutypes => {
        if (skutypes.sku===sku) {  
          price=skutypes.price;
          return;          
        }
    });
    return price;
  }

    return (
      <>
      {loading?<Spinner show={loading} />:null}
      {modalDetail!==""?modalDetail:null}
      <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded bg-gray-800">
        <div className="rounded-t mb-0 px-4 py-3 bg-transparent">
          <div className="flex flex-wrap items-center">
            <div className="relative w-full max-w-full flex-grow flex-1">
              <h6 className="uppercase text-gray-200 mb-1 text-xs font-semibold">
              {props.header}
              </h6>
              <h2 className="text-white text-xl font-semibold">{props.title}</h2>
            </div>
          </div>
        </div>
        <div className="flex-auto">
          <div className="w-full flex justify-center">
              <img
                alt="{props.title}"
                src={require("assets/img/"+props.img)}
                className="shadow-xl h-auto align-middle border-none"
              />
          </div>
          <div className="p-4 relative h-100-px text-white">
              {props.desc}
          </div>
          <div className="relative h-70-px text-white flex flex-wrap justify-center">
            <div className="w-12/12 px-4">
                <button className="mx-auto text-white-500 border border-solid border-blue-500 hover:bg-blue-500 hover:text-white active:bg-blue-600 font-bold uppercase text-sm px-3 py-3 rounded outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" 
                type="button"
                onClick={(e)=>doPayment(getPrice(props.sku))}
                >
                  BUY {getPrice(props.sku)} EUR 
                </button>
                {props.download?
                <button className="mx-auto text-white-500 border border-solid border-blue-500 hover:bg-blue-500 hover:text-white active:bg-blue-600 font-bold uppercase text-sm px-3 py-3 rounded outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" 
                type="button"
                onClick={()=> window.open(props.download, "_blank")}
                >
                  DOWNLOAD 
                </button>                
                :null}
              </div>
          </div>
        </div>
      </div> 
      </>
    );
}
